import { Colors, Services } from '@sigma-frontend-libs/commons'

import { sizes } from '@/utils'

import entityInfo from '@/components/entity/info'
import FormTitle from '@/components/misc/FormTitle'
import selectorSendingType from '@/components/selector/sendingType'
import TariffsDoubleButtons from '@/components/services/tariffs/buttons/double'
import TariffsThirdCol from '@/components/services/tariffs/cols/third'
import tag from '@/components/tag'
import textOverflow from '@/components/text/overflow'

function renderTitle(h, item) {
  return h(
    textOverflow,
    {
      props: {
        value: item.title
      }
    }
  )
}
function renderType(h, item) {
  const [ source, type ] = item.source && item.source.split('.') || []
  const sourceOrType = type || source

  return h(
    tag,
    {
      props: {
        label: this.getTranslate(`${Services.sendings}.types.${sourceOrType}`),
        size: sizes.small,
        color: Colors[sourceOrType]
      }
    }
  )
}
function renderSearchGeneratorItem(h, item) {
  return h(
    'router-link',
    {
      class: {
        'search-generator__item': true,
        'search-generator__item--active': item.id === this.$route.params.id
      },
      props: {
        to: {
          name: `${Services.tariffs}.single`,
          params: { id: item.id }
        }
      },
      key: item.id
    },
    [
      h(
        'div',
        {
          class: 'search-generator__item-content'
        },
        [
          renderTitle.call(this, h, item),
          renderType.call(this, h, item)
        ]
      )
    ]
  )
}
function renderSearchGenerator(h) {
  return h(
    'search-generator',
    {
      scopedSlots: {
        filter: ({ filter }) => {
          return h(
            selectorSendingType,
            {
              props: {
                value: filter.source,
                label: this.getTranslate(`${Services.tariffs}.labels.source`),
                items: this.sourceItems
              },
              on: {
                input: event => {
                  filter.source = event
                }
              }
            }
          )
        },
        default: ({ item }) => {
          return renderSearchGeneratorItem.call(this, h, item)
        }
      }
    }
  )
}

function renderTemplate(h) {
  return h(
    'legacy-template',
    {
      scopedSlots: {
        title: ({ data, validation, setData, setTitleValidation }) => {
          return h(
            'div',
            {
              class: `${Services.tariffs}-title`
            },
            [
              h(
                FormTitle,
                {
                  props: {
                    value: data
                  },
                  on: {
                    input: event => {
                      setData(event)
                    },
                    validation: event => {
                      setTitleValidation(event)
                    }
                  }
                }
              ),

              h(
                TariffsDoubleButtons,
                {
                  props: {
                    value: data,
                    validation
                  }
                }
              )
            ]
          )
        },
        'after-form': ({ data }) => {
          return h(entityInfo, { props: { value: data } })
        },
        right: () => {
          return h(TariffsThirdCol)
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: Services.tariffs
    },
    [
      renderSearchGenerator.call(this, h),
      renderTemplate.call(this, h)
    ]
  )
}
